import { useCallback, useState } from 'react';
import { api, type MyInvite } from '../lib/api';

// Pending invitations to additional families (decision D3). An existing user
// accepts in-app — no re-registration, since handles are global.
// Consumers decide when to refresh (the app shell refreshes on navigation).
export function useInvites() {
  const [invites, setInvites] = useState<MyInvite[]>([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.getMyInvites();
      setInvites(response.data);
    } catch {
      // A failed invite fetch must never break navigation
      setInvites([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const accept = useCallback(
    async (inviteId: string) => {
      const response = await api.acceptInvite(inviteId);
      await refresh();
      return response.data;
    },
    [refresh]
  );

  const decline = useCallback(
    async (inviteId: string) => {
      const response = await api.declineInvite(inviteId);
      await refresh();
      return response.data;
    },
    [refresh]
  );

  return {
    invites,
    count: invites.length,
    loading,
    refresh,
    accept,
    decline,
  };
}
